import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useHeader } from "@/composables/use-header";


export default /*@__PURE__*/_defineComponent({
  __name: 'header-hamburger-button',
  setup(__props) {

const { toggleMenu } = useHeader();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-menu",
    id: "btn-menu",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleMenu) && _unref(toggleMenu)(...args)))
  }, _cache[1] || (_cache[1] = [
    _createElementVNode("span", { class: "btn-menu__hamburger" }, [
      _createElementVNode("span", { class: "btn-menu__hamburger-inner" })
    ], -1)
  ])))
}
}

})